import React from 'react';

import { Text, TextProps } from '@mantine/core';
import { PACKAGE_TYPE_TOOLTIP_MESSAGES } from 'components/KiloTooltip';
import { Package } from 'types/generated';

interface IPackageTypeDescriptionProps extends TextProps {
  type: Package['type'];
}

/** A one-line, plain-language explanation of how a package type renews. */
const PackageTypeDescription = ({ type, ...textProps }: IPackageTypeDescriptionProps): JSX.Element => (
  <Text color='dark.3' data-cy={`packageTypeDescription-${type}`} {...textProps}>
    {PACKAGE_TYPE_TOOLTIP_MESSAGES[type]}
  </Text>
);

export default PackageTypeDescription;
